var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "物流查询",
        visible: _vm.visible,
        width: "600px",
        "append-to-body": "",
        "custom-class": "logistics-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "dialog-content" },
        [
          _c("div", { staticClass: "logistics acea-row row-top" }, [
            _c("div", { staticClass: "logistics_img" }, [
              _c("img", {
                attrs: { src: require("@/assets/imgs/expressi.jpg") },
              }),
            ]),
            _c("div", { staticClass: "logistics_cent" }, [
              _c("span", { staticClass: "mb10" }, [
                _vm._v("物流公司：" + _vm._s(_vm.expressName)),
              ]),
              _c("span", [_vm._v("物流单号：" + _vm._s(_vm.trackingNumber))]),
            ]),
          ]),
          _vm.hasLogisticsData
            ? _c(
                "div",
                { staticClass: "acea-row row-column-around trees-coadd" },
                [
                  _c(
                    "div",
                    { staticClass: "scollhide" },
                    [
                      _c(
                        "el-timeline",
                        _vm._l(_vm.logisticsInfo.list, function (item, index) {
                          return _c("el-timeline-item", { key: index }, [
                            _c("p", { staticClass: "time" }, [
                              _vm._v(_vm._s(item.time)),
                            ]),
                            _c("p", { staticClass: "content" }, [
                              _vm._v(_vm._s(item.status)),
                            ]),
                          ])
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ]
              )
            : _c("el-empty", {
                attrs: { description: "暂无物流信息~", "image-size": 120 },
              }),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.close } },
            [_vm._v("关闭")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }